"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _intlI18n = require("@/i18n/intl-i18n");
var _IntlBreadcrumb = _interopRequireDefault(require("../components/IntlBreadcrumb.vue"));
var _international = require("@/api/international");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// ============================================================
// 动态详情页逻辑
// ============================================================
var _default = exports.default = {
  name: 'IntlNewsDetail',
  mixins: [_intlI18n.intlMixin],
  components: {
    IntlBreadcrumb: _IntlBreadcrumb.default
  },
  data: function data() {
    return {
      news: null,
      loadFailed: false
    };
  },
  computed: {
    newsTitle: function newsTitle() {
      if (!this.news) return '';
      return this.pickLang(this.news, 'title');
    },
    newsSource: function newsSource() {
      if (!this.news) return '';
      return this.pickLang(this.news, 'source');
    },
    newsContent: function newsContent() {
      if (!this.news) return '';
      return this.pickLang(this.news, 'content');
    }
  },
  methods: {
    pickLang: function pickLang(item, base) {
      return item[base] || '';
    },
    loadDetail: function () {
      var _loadDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, res, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              id = this.$route.query.id;
              if (id) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              this.loadFailed = false;
              _context.prev = 2;
              _context.next = 3;
              return (0, _international.getNewsDetail)(id);
            case 3:
              res = _context.sent;
              if (res.data.code === 200) this.news = res.data.data;
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](2);
              console.error('loadDetail', _t);
              this.news = null;
              this.loadFailed = true;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 4]]);
      }));
      function loadDetail() {
        return _loadDetail.apply(this, arguments);
      }
      return loadDetail;
    }()
  },
  watch: {
    '$intlLang': function $intlLang() {
      this.loadDetail();
    }
  },
  mounted: function mounted() {
    this.loadDetail();
  }
};